import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';
import styled from 'styled-components';

import media from 'media';

import IconComponent from 'components/IntroPanel/IconComponent';
import infoIcon from 'assets/svg/infopanel/icon_infoboard.svg';
import closeIcon from 'assets/svg/navigation/icon_close_2.svg';
import linkIcon from 'assets/svg/navigation/icon_navigation_right.svg';

import logoKSO from 'assets/png/infopanel/logo_kso.png';
import logoAdelphi from 'assets/png/infopanel/adelphi_logo@2x.png';
import logoHDE from 'assets/png/infopanel/HDE_Logo@2x.png';
import logoBund from 'assets/png/infopanel/BMWi_EnEffi_logo @2x.png';
import logoBMUD from 'assets/png/infopanel/BMUB_NKI_logo@2x.png';
import { Mobile, TabletUp } from '../../media';

const H1 = styled.h1`
  font-size: 2.25rem;
  line-height: 1.06;
  margin: .88rem 0;
  ${media.tablet`
    // margin: .75rem 0 0.38rem 0;
    font-size: 1.5rem;
  `}
`;
const P = styled.p`
  font-size: 1rem;
  margin: 0 0 .69rem 0;
  line-height: 1.25;
  ${media.tablet`
    margin: .75rem 0 0.38rem 0;
    font-size: .94rem;
    line-height: 1.26;
  `}
`;

const LogoImg = styled.img`
  height: 5.13rem;
  ${media.tablet`
    height: 4.48rem;
  `}
`;
const KlimaschutzImg = styled.img`
  height: 12.44rem;
  margin-left: 4rem;
  ${media.tablet`
    height: 10.83rem;
  margin-left: 0rem;
  `}
`;

const LogoRow = styled.div`
  margin: 1.5rem 0; 
  display: flex;
  ${(props) => {
    if (props.start) {
      return 'justify-content:start;';
    }
    return 'justify-content:space-between;';
  }}
  ${(props) => (props.equalWidth && `
    > * {
    flex: 1 1 auto;
    }
  `)}
`;
const ImprintLink = styled.a`
  font-size:1.1rem;
  line-height: 1.2;
  color:#1C7EA7;
  text-decoration:none;
`;

const InfoPanelWrapper = styled.div`
  position:fixed;
  cursor:pointer;
  text-align: left;
  top: 0;
  right: 0;
  background: white;
  box-shadow: 0 0 20px 0 rgba(0,0,0,0.08);
  width: 42.88rem;
  min-height: 12rem;
  padding: 1.75rem 5.88rem 1rem 2.75rem;
  box-sizing: border-box;
  ${media.tablet`
    width: 100vw;
    height: 100vh;
    overflow-y: scroll;
    padding-left: 1.88rem;
    padding-top: .5rem;
    padding-right: 3.13rem;
  `}
`;

const InfoIconWrapper = styled.button`
  position:fixed;
  cursor:pointer;
  display:flex;
  justify-content: center;
  align-items: center;
  top: 1.25rem;
  right: 1.25rem;
  background: white;
  ${(props) => (props.shadow && 'box-shadow: 0 0 10px 0 rgba(0,0,0,0.39);')}
  border-radius: 50%;
  border: none;
  width: 2.88rem;
  height: 2.88rem;
  ${media.tablet`
    width: 1.5rem;
    height: 1.5rem;
  `}
`;

const WrapInfoIcon = styled.div`
  .infoIconWrapper
  {
    img { 
    ${media.tablet`
      width: 0.6rem;
    `}
    }
  }
`;

const IconImg = styled.img`
  ${(props) => (props.width && `width: ${props.width}`)}
  ${(props) => (props.height && `height: ${props.height}`)}
`;

const InfoIcon = (props) => (
  <InfoIconWrapper className="infoIconWrapper" shadow={props.shadow} onClick={props.onClick}><IconImg {...props} src={props.src} alt="close" /></InfoIconWrapper>
);

InfoIcon.propTypes = {
  // description: PropTypes.string.isRequired,
  shadow: PropTypes.bool,
  maximizeImage: PropTypes.bool,
  src: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  // pos: PropTypes.string.isRequired,
  // title: PropTypes.string.isRequired,
};

class TogglePanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  handleClick = (event) => {
    this.setState({ open: true });
    event.stopPropagation();
  }
  handleCloseClick = () => {
    this.setState({ open: false });
  }
  render() {
    const { open } = this.state;
    return (
      <div style={{ position: 'relative', zIndex: 5 }}>
        <WrapInfoIcon>
          <InfoIcon shadow onClick={this.handleClick} src={infoIcon} />
        </WrapInfoIcon>
        <CSSTransition
          in={open}
          timeout={750}
          classNames="intro"
          unmountOnExit
        >
          {(state) => (
            <div>
              <InfoPanelWrapper>
                <InfoIcon width="100%" height="100%" onClick={this.handleCloseClick} src={closeIcon} />
                <H1>Virtuelle Marktstraße</H1>
                <P>
                  Den Klimaschutz im Einzelhandel zu stärken ist unsere Aufgabe. Wie können Energiekosten eingespart und gleichzeitig mit Maßnahmen für den Klimaschutz im Einzelhandel verknüpft werden?
                </P>
                <P>
                  Diese Fragen bilden den Ausgangspunkt der Klimaschutzoffensive des Handels. Die Virtuelle Marktstraße ist ein wichtiger Baustein, auf anschauliche Weise Antworten dazu zu liefern.
                </P>
                <P>
                  Für Anmerkungen können Sie uns gerne unter <a href="mailto:klimaschutz@hde.de">klimaschutz@hde.de</a> kontaktieren.
                </P>
                <LogoRow>
                  <a rel="noopener noreferrer" target="_blank" href="https://www.hde-klimaschutzoffensive.de/de/start"><LogoImg src={logoKSO} alt="Logo: KSO" /></a>
                  <a rel="noopener noreferrer" target="_blank" href="https://www.einzelhandel.de/"><LogoImg src={logoHDE} alt="Logo: HDE" /></a>
                  <TabletUp>
                    <a rel="noopener noreferrer" target="_blank" href="https://www.adelphi.de/de"><LogoImg src={logoAdelphi} alt="Logo: Adelphi" /></a>
                  </TabletUp>
                </LogoRow>
                <Mobile>
                  <LogoRow equal>
                    <a rel="noopener noreferrer" target="_blank" href="http://www.deutschland-machts-effizient.de/"><LogoImg src={logoBund} alt="Logo: Deutschland macht's effizient" /></a>
                    <a rel="noopener noreferrer" target="_blank" href="https://www.adelphi.de/de"><LogoImg src={logoAdelphi} alt="Logo: Adelphi" /></a>
                  </LogoRow>
                  <LogoRow equalWidth>
                    <a rel="noopener noreferrer" target="_blank" href="https://www.klimaschutz.de"><KlimaschutzImg src={logoBMUD} alt="Logo: Nationale Klimaschutzoffensive" /></a>
                  </LogoRow>
                </Mobile>
                <TabletUp>
                  <LogoRow start>
                    <a rel="noopener noreferrer" target="_blank" href="http://www.deutschland-machts-effizient.de/"><LogoImg src={logoBund} alt="Logo: Deutschland macht's effizient" /></a>
                    <a rel="noopener noreferrer" target="_blank" href="https://www.klimaschutz.de"><KlimaschutzImg src={logoBMUD} alt="Logo: Nationale Klimaschutzoffensive" /></a>
                  </LogoRow>
                </TabletUp>
                <ImprintLink target="_blank" href="https://www.hde-klimaschutzoffensive.de/de/impressum"><IconComponent iconAlt="Link: Impressum" iconUrl={linkIcon}>Impressum</IconComponent></ImprintLink>
              </InfoPanelWrapper>
            </div>
          )}
        </CSSTransition>
      </div>
    );
  }
}

TogglePanel.propTypes = {
};

TogglePanel.defaultProps = {
//   link: null,
};

export default TogglePanel;



// WEBPACK FOOTER //
// ./src/components/InfoIcon/TogglePanel.js